import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/fifteen_puzzle.json";
import fr from "@/locales/fr/puzzle-types/fifteen_puzzle.json";

export const FIFTEEN_NS = "puzzle-types/fifteen_puzzle";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerFifteenTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", FIFTEEN_NS))
    i18n.addResourceBundle("en", FIFTEEN_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", FIFTEEN_NS))
    i18n.addResourceBundle("fr", FIFTEEN_NS, fr, true, true);
}
